import axios from "axios";

const url = "/api/";

class PostService {
  static getSong() {
    let urlParams = new URLSearchParams(window.location.search);
    let accestoken = urlParams.get("access_token");
    return new Promise((resolve, reject) => {
      axios
        .get(`${url}nowplaying?access_token=${accestoken}`)
        .then((res) => {
          const data = res.data;
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  static postToken() {
    let urlParams = new URLSearchParams(window.location.search);
    let refresh_token = urlParams.get("refresh_token");
    return new Promise((resolve, reject) => {
      axios
        .post("https://accounts.spotify.com/api/token", {
          grant_type: "refresh_token",
          refresh_token: refresh_token,
        })
        .then(function(res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
export default PostService;
